
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "../../../store/store";

const baseUrl =process.env.REACT_APP_base_URL;

const createSolution = createApi({
    reducerPath: 'submitSolution',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // const token = useSelector((state)=> state.user.token)
            const token = store.getState().user.token;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        createSolution: builder.mutation({
            query: ({ userId, formData}) => ({
                url:`solution/createSolution`,
                method: 'POST',
                body: formData,
            }),
            transformResponse: (response) => {
                return response;
            },
        }),
    }),
});

export const { useCreateSolutionMutation } = createSolution;
export default createSolution;
